import { render, staticRenderFns } from "./MspAttivitaPalestra.vue?vue&type=template&id=2f895870"
import script from "./MspAttivitaPalestra.vue?vue&type=script&lang=js"
export * from "./MspAttivitaPalestra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports